export default __webpack_public_path__ + "static/media/triangletwo-right.c7b52e1e.svg";